import React, { useState } from 'react';
import { Button, Form, Image } from 'react-bootstrap';
import DataTable from 'react-data-table-component';
import { FaBan, FaCheck, FaCity, FaPhone, FaRegEnvelope, FaUser } from 'react-icons/fa';
import tribu from './assets/images/logo_tribu.png'; // Importez le chemin de votre image


const TribuAction = ({ gotoAuth, annee, adherentSel, tribus, handleAfterModif }) => {

    const url = localStorage.getItem('url');
    const code = localStorage.getItem('code');

    const [newIdentifiant, setNewIdentifiant] = useState(adherentSel.identifiant_tribu ? adherentSel.identifiant_tribu : '');

    const verifIdentifiant = (identifiant) => {
        return tribus.filter(item => item.login === identifiant).length > 0;
    }

    const [newIdentifiantExist, setNewIdentifiantExist] = useState(adherentSel.identifiant_tribu ? verifIdentifiant(adherentSel.identifiant_tribu) : false);

    const handleNewIdentifiant = (e) => {
        setNewIdentifiant(e.target.value);
        setNewIdentifiantExist(verifIdentifiant(e.target.value));
    }

    const urltribu = `https://webservices.k-lix.com/TribuPrd.aspx`;

    const ModifTribu = (table, id, champ, valeur) => {
        console.log('Modif :', table, id, champ, valeur);
        // return;
        let obj = { action: 'updateobj', table, ID:id, [champ]:valeur };

        //Post
        fetch(urltribu, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify(obj)
        })
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                handleAfterModif();
            })
            .catch(error => console.error('Erreur:', error));
    }

    const ModifCrm = (table, id, champ, valeur) => {
        console.log('Modif :', table, id, champ, valeur);
        // return;
        fetch(`${url}modifCrm/${table}/${id}/${champ}/${valeur}/${code}`)
            .then(response => response.json())
            .then(data => {
                console.log('Réponse du serveur:', data);
                // getAdherent().then(() => filtreAll(boutonSel, adherents));
            })
            .catch(error => console.error('Erreur:', error));
    }

    const columnsTribu = [
        {
            name: 'adresse', selector: row => row.adresse, cell: row => (<table>
                <tbody>
                    <tr><td><b>{row.nom}</b></td></tr>
                    {row.mail && <tr><td><FaRegEnvelope />&nbsp;{row.mail}</td></tr>}
                    <tr><td><FaCity />&nbsp;{row.adresse}</td></tr>
                    <tr><td><FaCity />&nbsp;{row.cp} {row.ville}</td></tr>
                </tbody>
            </table>),
            sortable: true, wrap: true
        },
        { name: 'login', selector: row => row.login, sortable: true, wrap: true },
        { name: 'acces_interdit', selector: row => row.acces_interdit, sortable: true, wrap: true },
        { name: 'reseau', selector: row => row.reseau, sortable: true, wrap: true },
    ]

    const newGarage = (NOM, ADRESSE, LOGIN, PASSWORD, VILLE, CP, TEL, MAIL, RESEAU) => {
        return { action: 'newobj', table: "t_garage", NOM, ADRESSE, LOGIN, PASSWORD, VILLE, CP, TEL, MAIL, RESEAU, ADMIN: 0, AFFICHE_MESSAGE: 1, ACCES_INTERDIT: 0, SUPPRIMER: 0 }
    }

    const validHasTribu = (id) => {
        console.log('Modif :', 'tribu', id, 'has_tribu', 1);
        ModifCrm('tribu', id, 'has_tribu', 1);
        console.log('Modif :', 'tribu', id, 'fin_periode', `${annee}-12-31`);
        ModifCrm('tribu', id, 'fin_periode', `${annee}-12-31`);
        setTimeout(() => {
            handleAfterModif();
        }, 1000);
        alert('Modification effectuée');
    }

    const handleRowClickCreateNewGarageTribu = (row) => {
        console.log('Ligne cliquée :', row);
        console.log(row.nom_de_l_entreprise, row.adresse1, newIdentifiant, 'P@ssword', row.ville, row.code_postal, row.telephone, row.e_mail_2 ? row.e_mail_2 : row.e_mail_1 ? row.e_mail_1 : row.e_mail_3, row.reseau);
        let obj = newGarage(row.nom_de_l_entreprise, row.adresse1, newIdentifiant, 'P@ssword', row.ville, row.code_postal, row.telephone, row.e_mail_2 ? row.e_mail_2 : row.e_mail_1 ? row.e_mail_1 : row.e_mail_3, row.reseau);
        console.log(obj);



        if (window.confirm(`Ce compte sera créé dans tribu : ${obj.LOGIN} ${obj.PASSWORD}`)) {
            //POST
            fetch(urltribu, {
                method: 'POST', headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(obj)
            })
                .then(response => response.json())
                .then(data => {
                    console.log('Réponse du serveur:', data);
                    //getAdherent().then(() => filtreAll(boutonSel, adherents));
                    // console.log('Modif :', 'tribu', row.t_id, 'login', newIdentifiant);
                    ModifCrm('tribu', row.t_id, 'login', newIdentifiant);
                    // console.log('Modif :', 'tribu', row.t_id, 'has_tribu', 1);
                    ModifCrm('tribu', row.t_id, 'fin_periode', `${annee}-12-31`);
                    ModifCrm('tribu', row.t_id, 'has_tribu', 1);
                    setTimeout(() => {
                        handleAfterModif();
                    }, 1000);
                    ;

                })
                .catch(error => {
                    console.error('Erreur:', error)
                    alert('Erreur lors de la création du compte dans tribu');
                    alert('Merci de contacter le support\r\n' + error);
                });
        }
    }


    const handleRowClickSelTribu = (row) => {
        if (window.confirm(`Etes-vous sûr de vouloir modifier cet adhérent ? \r\nDans tribu :\r\nSon identifiant tribu sera ${row.login} et sa fin de période sera ${annee + 1}-01-31.${row.acces_interdit === 1 ? `\r\nDans tribu :\r\nIl est non actif il va être activé.` : ''}`)) {
            console.log('Ligne cliquée :', row);
            // update table tribu set identifiant_tribu = login
            console.log('Modif :', 'tribu', adherentSel.t_id, 'identifiant_tribu', row.login);
            ModifCrm('tribu', adherentSel.t_id, 'identifiant_tribu', row.login);
            ModifCrm('tribu', adherentSel.t_id, 'fin_periode', `${annee}-12-31`);
            if (row.acces_interdit === 1) {
                // alert('TODO : Il faut changer le statut de l\'adhérent dans tribu (a vérifier si OK)');
                ModifTribu('T_GARAGE', row.id, 'acces_interdit', 0);
            }
            setTimeout(() => {
                handleAfterModif();
            }, 1000);
            ;
            alert('Modification effectuée');
        }
    };

    //submit
    const handleSubmit = (e) => {
        e.preventDefault();
        console.log('submit');
        handleRowClickCreateNewGarageTribu(adherentSel);
    }


    return (
        <>
            <div className='row'>
                <div className='col-6'>
                    <h2>Adhérent</h2>
                    {adherentSel.nom_de_l_entreprise}<br />
                    <FaUser /> {adherentSel.nom_adherent} {adherentSel.prenom_adherent}<br />
                    <FaCity /> {adherentSel.adresse1}<br />
                    <FaCity />{adherentSel.code_postal} {adherentSel.ville}<br />
                    {adherentSel.e_mail_1 && (<><FaRegEnvelope /> {adherentSel.e_mail_1}<br /></>)}
                    {adherentSel.e_mail_2 && (<><FaRegEnvelope /> {adherentSel.e_mail_2}<br /></>)}
                    {adherentSel.e_mail_3 && (<><FaRegEnvelope /> {adherentSel.e_mail_3}<br /></>)}
                    {adherentSel.telephone && (<><FaPhone /> {adherentSel.telephone}<br /></>)}
                    {adherentSel.reseau && (<>Réseau : {adherentSel.reseau}<br /></>)}
                    {adherentSel.identifiant_tribu && (<><Image src={tribu} style={{ width: '40px' }} /> {adherentSel.identifiant_tribu}<br /></>)}
                </div>
                {(adherentSel.nom_de_l_entreprise === null || adherentSel.nom_de_l_entreprise === '' ||
                    adherentSel.adresse1 === null || adherentSel.adresse1 === '' ||
                    adherentSel.code_postal === null || adherentSel.code_postal === '' ||
                    adherentSel.ville === null || adherentSel.ville === '' ||
                    ((adherentSel.e_mail_1 === null || adherentSel.e_mail_1 === '') &&
                        (adherentSel.e_mail_2 === null || adherentSel.e_mail_2 === '') &&
                        (adherentSel.e_mail_3 === null || adherentSel.e_mail_3 === ''))) &&
                    <div className='col-6'>
                        <h2>Merci de compléter les informations de l'adhérent : </h2>
                        {(adherentSel.nom_de_l_entreprise === null || adherentSel.nom_de_l_entreprise === '') && <><FaUser /> Nom de l'entreprise<br /></>}
                        {(adherentSel.adresse1 === null || adherentSel.adresse1 === '') && <><FaCity /> Adresse<br /></>}
                        {(adherentSel.code_postal === null || adherentSel.code_postal === '') && <><FaCity /> Code postal<br /></>}
                        {(adherentSel.ville === null || adherentSel.ville === '') && <><FaCity /> Ville<br /></>}
                        {(adherentSel.e_mail_1 === null || adherentSel.e_mail_1 === '') &&
                            (adherentSel.e_mail_2 === null || adherentSel.e_mail_2 === '') &&
                            (adherentSel.e_mail_3 === null || adherentSel.e_mail_3 === '') && <><FaRegEnvelope /> Email<br /></>}
                    </div>
                }

                {!(adherentSel.nom_de_l_entreprise === null || adherentSel.nom_de_l_entreprise === '' ||
                    adherentSel.adresse1 === null || adherentSel.adresse1 === '' ||
                    adherentSel.code_postal === null || adherentSel.code_postal === '' ||
                    adherentSel.ville === null || adherentSel.ville === '' ||
                    ((adherentSel.e_mail_1 === null || adherentSel.e_mail_1 === '') &&
                        (adherentSel.e_mail_2 === null || adherentSel.e_mail_2 === '') &&
                        (adherentSel.e_mail_3 === null || adherentSel.e_mail_3 === ''))) &&
                    adherentSel.login === null &&
                    <div className='col-6'>
                        <h2>Créer un compte dans tribu</h2>
                        <FaUser /> {adherentSel.nom_de_l_entreprise}<br />
                        <FaCity /> {adherentSel.adresse1}<br />
                        <FaCity /> {adherentSel.code_postal} {adherentSel.ville}<br />
                        {adherentSel.e_mail_2 && (
                            <>
                                <FaRegEnvelope /> {adherentSel.e_mail_2}
                                {adherentSel.mail && adherentSel.e_mail_2 === adherentSel.mail && (
                                    <Form.Text className="text-danger"><FaBan /> Mail déjà utilisé </Form.Text>
                                )}
                                <br />
                            </>
                        )}
                        {adherentSel.e_mail_1 && !adherentSel.e_mail_2 && (
                            <><FaRegEnvelope /> {adherentSel.e_mail_1}
                                {adherentSel.mail && adherentSel.e_mail_1 === adherentSel.mail && (
                                    <Form.Text className="text-danger"><FaBan />Mail déjà utilisé</Form.Text>
                                )}
                                <br />
                            </>
                        )}
                        {!adherentSel.e_mail_1 && !adherentSel.e_mail_2 && adherentSel.e_mail_3 && (
                            <>
                                <FaRegEnvelope /> {adherentSel.e_mail_3}
                                {adherentSel.mail && adherentSel.e_mail_3 === adherentSel.mail && (
                                    <Form.Text className="text-danger"><FaBan />Mail déjà utilisé</Form.Text>)}
                                <br />
                            </>
                        )}
                        <Form onSubmit={handleSubmit}>
                            <Form.Group controlId="formBasicEmail" style={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                                <Form.Label style={{ display: 'flex', alignItems: 'center', marginBottom: '0', marginRight: '10px' }}>
                                    <Image src={tribu} style={{ width: '40px', marginRight: '5px' }} />
                                    Identifiant :
                                </Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Identifiant"
                                    value={newIdentifiant}
                                    onChange={handleNewIdentifiant}
                                    style={{ flex: '1' }}
                                />
                            </Form.Group>
                            {newIdentifiantExist && <Form.Text className="text-danger"><FaBan /> Cet identifiant existe déjà</Form.Text>}
                            {!newIdentifiantExist && <Form.Text className="text-success"><FaCheck /> Cet identifiant est disponible</Form.Text>}<br />
                            <div className="d-grid gap-2">
                                <Button variant="primary" type="submit" disabled={newIdentifiantExist || !newIdentifiant.trim()}>
                                    Créer
                                </Button>
                            </div>
                        </Form>
                    </div>
                }
                {adherentSel.login !== null &&
                    <>
                        <div className='col-6'>
                            <h2>Compte tribu</h2>
                            <FaUser /> {adherentSel.nom}<br />
                            <FaCity /> {adherentSel.adresse}<br />
                            <FaCity /> {adherentSel.cp} {adherentSel.ville1}<br />
                            <FaRegEnvelope /> {adherentSel.mail}<br />
                            <Image src={tribu} style={{ width: '40px' }} /> {adherentSel.login}<br />

                        </div>
                        {/* {JSON.stringify(adherentSel)} */}
                        {(adherentSel.has_tribu_actif === 1 && adherentSel.has_tribu === 0)
                         && (<div className='col-12'>
                            <br />
                            Il y a un souci dans la base de données, l'utilisateur est abonné à tribu et has_tribu à 0
                            <div className="d-grid gap-2">
                                <Button variant="primary" onClick={() => validHasTribu(adherentSel.t_id)}>
                                    Mettre has_tribu à 1 et fin_periode à {annee}-12-31
                                </Button>
                            </div>
                        </div>)}
                        {(adherentSel.has_tribu_actif === 1 && adherentSel.acces_interdit === 1)
                         && (<div className='col-12'>
                            <br />
                            Il y a un souci dans la base de données, l'utilisateur est abonné à tribu et a un accès interdit dans tribu
                            <div className="d-grid gap-2">
                                <Button variant="primary" onClick={() => ModifTribu('T_GARAGE', adherentSel.tft_id, 'acces_interdit', 0)}>
                                    Mettre acces_interdit à 0 pour {adherentSel.nom}
                                </Button>
                            </div>
                        </div>)}
                    </>}
            </div>

            {tribus.filter(item => item.has_tribu_actif === 0 && item.cp === adherentSel.code_postal).length > 0 && <DataTable
                columns={columnsTribu}
                // data={tribus.filter(item => item.has_tribu_actif === 0 && item.acces_interdit === 0)}
                data={tribus.filter(item => item.has_tribu_actif === 0 && item.cp === adherentSel.code_postal)}
                pagination={true}
                paginationPerPage={10}
                paginationRowsPerPageOptions={[10, 20, 30, 50, 100]}
                highlightOnHover
                defaultSortField="id"
                defaultSortAsc={false}
                subHeaderAlign="left"
                noHeader={true}
                paginationComponentOptions={{
                    rowsPerPageText: 'Lignes par page:',
                }}
                onRowClicked={handleRowClickSelTribu}
            />}
        </>);
}

export default TribuAction;
